<template>
  <div ref="editorElem" class="wang-editor-wrapper"></div>
</template>

<script>
import E from 'wangeditor'

export default {
  name: 'WangEditor',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editor: null,
      html: this.value
    }
  },
  watch: {
    value(val) {
      if (val !== this.html) {
        this.html = val
        if (this.editor && val !== this.editor.txt.html()) {
          this.editor.txt.html(val || '')
        }
      }
    }
  },
  mounted() {
    this.editor = new E(this.$refs.editorElem)
    this.editor.config.onchange = (newHtml) => {
      this.html = newHtml
      this.$emit('input', newHtml)
    }
    this.editor.config.height = 500
    this.editor.create()
    if (this.value) {
      this.editor.txt.html(this.value)
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  }
}
</script>

<style scoped>
.wang-editor-wrapper {
  min-height: 300px;
}
</style>
